import { breakpointNames } from "../../css/breakpoints.mjs";
function resolveResponsiveObject(breakpointName, value) {
  let resolvedValue = null;
  for (let i = 0; i < breakpointNames.length; i++) {
    const currentBreakpointName = breakpointNames[i];
    const valueForBreakpoint = value[currentBreakpointName];
    if (valueForBreakpoint !== void 0) {
      resolvedValue = valueForBreakpoint;
    }
    if (breakpointName === currentBreakpointName) {
      return resolvedValue;
    }
  }
  return resolvedValue;
}
export {
  resolveResponsiveObject
};
